export const sugaredMashedBeans = {
  id: "sugaredMashedBeans",
  link: "/#/recipes/recipes/sugaredMashedBeans",
  name: "Sugared Mashed Beans",
  cuisine: "Horneater",
  summary: "Chunky sweet bean paste",
  inspiration: "Tsubuan",
  quantity: "about 1 1/2 cups",
  time: "2 1/2 hours",
  notes:
    "The description here seemed pretty straightforward - sugared mashed beans sounds like sweet bean paste. The only difference was that they were mentioned as a standalone dish, not a filling for something else (Rhythm of War Interlude I-5). When the books mention sweet beans elsewhere as a filling, they call it bean paste, not mashed beans (Words of Radiance ch 62). So I've chosen to interpret this as something distinct from the smooth sweet bean paste filling, and make it chunky. Having this be different than the bean paste used in Alethi recipes makes sense, since this was prepared by a Horneater. It also helps that chunky bean paste is easier to make. I went with kidney beans rather than adzuki beans because they're easier to find at the grocery store, and we are trying to make something new after all, not just copying existing earth recipes exactly. Feel free to use any type of dried bean that has some sweetness to it.",
  quotes:
    "She rifled through the basket. Flatbread … some curry … sugared mashed beans … a little jar of jam with a cute face drawn on top above the Horneater symbol for “love.” (Rhythm of War Interlude I-5)",
  image:
    "https://jozomby-public.s3.amazonaws.com/recipes/sugared-mashed-beans-overview.jpg",
  ingredientSections: [
    {
      title: null,
      ingredients: [
        {
          item: "driedBeans",
          display: "1 cup dry kidney beans"
        },
        {
          item: "water",
          display: "water for boiling"
        },
        {
          item: "sugar",
          display: "3/4 cup granulated sugar"
        },
        {
          item: "salt",
          display: "1/2 tsp salt"
        }
      ]
    }
  ],
  steps: [
    "Rinse the kidney beans. Place in a pot, cover with water so that the level of water is about 2 inches above the beans, then bring to boil over high heat.",
    "Drain the water and place the beans back in the pot. Cover with water (2 inches above beans) again and bring back to a boil. Cover the pot and reduce heat to simmer for 1 hour 45 minutes until the beans are soft. You may need to add additional water around the 1 hour mark.",
    "Remove the pot from the heat. Drain the beans and return them to the pot. Set over medium low heat, add sugar and salt, then stir cook until the sugar and salt are dissolved.",
    "Mash the beans thoroughly until you get a somewhat chunky paste. Continue to cook and stir for 5 more minutes to thicken a bit more.",
    "Empty the pot onto a baking sheet and spread the mashed beans out into a thin layer. Let them cool. When cool, scrape the beans off the sheet into a storage container."
  ]
}
